<template>
  <v-card class="mx-auto rounded-0" tile flat>
    <v-list-item three-line>
      <v-list-item-content>
        <div class="text-overline mb-1 black--text font-weight-black">
          {{uiConf.copyright}}
        </div>
        <v-list-item-title class="text-subtitle-2 mb-1">
          www  : <a class="black--text" :href="uiConf.ownerURL" target="_blank">{{uiConf.ownerURL}}</a><br>
          email: <a class="black--text" :href="'mailto' + uiConf.mailAddress">{{uiConf.mailAddress}}</a><br>
        </v-list-item-title>
        <v-list-item-subtitle class="mt-1 text-caption">{{uiConf.postalAddress}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: 'addressCard',
  data: () => ({
  }),
  computed: {
    uiConf: {
      get: function () {
        return this.$store.getters.getUIConf
      }
    }
  }
}
</script>
